// Hide incident tracking and email screens; report preparation remains available.
export const SHOW_SIFEN_INCIDENTS = false;
